<header>
  <div class="container-small">
    <div class="header">
      <div class="header__logo">
        <img src="assets/images/removia-logo-white.svg" alt="logo" />
      </div>
      <div class="lang-switcher">
        <!-- <button
          *ngFor="let l of lang.SUPPORTED_LANGS"
          (click)="lang.setLang(l)"
          [class.lang-btn-active]="lang.currentLang === l"
          class="lang-btn"
        >
          {{ l.toUpperCase() }}
        </button> -->
        <button
          class="lang-globe-btn"
          (click)="openLangModal()"
          [attr.aria-label]="'Change language'"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="2" y1="12" x2="22" y2="12" />
            <path
              d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
            />
          </svg>
          <span class="lang-globe-label">{{
            lang.currentLang.toUpperCase()
          }}</span>
        </button>
      </div>
      <div class="header__btn">
        <a href="#plan" id="scroll-down" class="desktop button default">
          <!-- Get protected -->
          {{ "buy-now.protected" | translate }}
        </a>
        <a href="#plan" id="scroll-down-mobile" class="mobile button default">
          {{ "buy_now_long_term.plans.title-end" | translate }}
          <!-- Plan -->
        </a>
        <a href="#" target="_blank" class="button grad">
          <!-- Log in  -->
          {{ "buy-now.login" | translate }}
        </a>
      </div>
    </div>
  </div>
</header>
<app-landing-main></app-landing-main>
<app-landing-pricing></app-landing-pricing>
<app-landing-footer></app-landing-footer>
<div
  class="lang-modal-overlay"
  [class.active]="isLangModalOpen"
  (click)="closeLangModal()"
>
  <div class="lang-modal" (click)="$event.stopPropagation()">
    <div class="lang-modal__header">
      <span class="lang-modal__title">{{ "choose_language" | translate }}</span>
      <button class="lang-modal__close" (click)="closeLangModal()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
    <div class="lang-modal__list">
      <button
        *ngFor="let l of langOptions"
        class="lang-modal__item"
        [class.lang-modal__item--active]="lang.currentLang === l.code"
        (click)="selectLang(l.code)"
      >
        <span class="lang-modal__flag">{{ l.flag }}</span>
        <span class="lang-modal__name">{{ l.name }}</span>
        <span class="lang-modal__code">{{ l.code.toUpperCase() }}</span>
        <svg
          *ngIf="lang.currentLang === l.code"
          class="lang-modal__check"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </button>
    </div>
  </div>
</div>
